export default __webpack_public_path__ + "static/media/Serika_Newyear.6e935271.png";